<script>
    import { fly } from "svelte/transition";

    const cookieTimeout = 31104000000; // 12 months in milliseconds
    const cookieName = "hasConsent";

    function setConsent() {
        var date = new Date();
        date.setTime(date.getTime() + cookieTimeout);
        localStorage.setItem(cookieName, true);
        consent = true;
    }

    function hasConsent() {
        return localStorage.getItem(cookieName);
    }

    let consent = false;
    let bots = /bot|crawler|spider|crawling/i;
    if (bots.test(navigator.userAgent) || hasConsent()) {
        consent = true;
    }
</script>

{#if !consent}
    <div in:fly={{ y: -200, duration: 2000 }} out:fly={{ y: -50, duration: 2000 }}>
        <p>
            Nous utilisons des cookies pour personnaliser le contenu. En naviguant sur le site vous
            acceptez notre
            <a href="https://mariage-parfait.com/cookies" target="_blank">Politique de cookies</a>
        </p>
        <button class="close-icon" on:click={setConsent}>x</button>
    </div>
{/if}

<style>
    div {
        align-items: center;
        background: #efefef;
        display: flex;
        padding: 5px;
        font-size: 10px;
        position: fixed;
        z-index: 100;
        width: 100%;
    }

    p {
        margin: 0;
        padding-right: 26px;
    }

    button.close-icon {
        position: absolute;
        right: 10px;
        z-index: 9999;
        width: 25px;
        color: #666;
        font-size: 18px;
        line-height: 1;
        outline: 0;
        cursor: pointer;
        text-align: center;
        border: none;
        padding: 0;
    }
</style>
